import { render, staticRenderFns } from "./popularScenicArea.vue?vue&type=template&id=7a096939&scoped=true"
import script from "./popularScenicArea.vue?vue&type=script&lang=js"
export * from "./popularScenicArea.vue?vue&type=script&lang=js"
import style0 from "./popularScenicArea.vue?vue&type=style&index=0&id=7a096939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a096939",
  null
  
)

export default component.exports